import React, { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Col, Spin, Tree, Checkbox, Popover, Button, Space, Radio } from 'antd';
import { FolderOpenOutlined, SearchOutlined, SkinOutlined, SkinFilled } from '@ant-design/icons';
import { isEqual, debounce, cloneDeep } from 'lodash';
import { callApi } from 'utils';
import { SelectContext } from '../context';

const prefixClx = 'select-modal-new';
const TreeNode = Tree.TreeNode;

function setNodeJobSubdivide(list, jobSubdivide) {
	return list?.map((item) => {
		item.jobSubdivide = jobSubdivide;
		return item;
	});
}

// 查询组件类型
const componentType = {
	USER: 'user',
	DEPARTMENT: 'department',
	STATION: 'station',
	ALL: 'all',
};

const JobSubdivideEnum = {
	POSITION: undefined,
	SPACE: 1,
};
const JobSubdivideOptions = [
	{ label: '按岗位职能', value: JobSubdivideEnum.POSITION },
	{ label: '按责任空间', value: JobSubdivideEnum.SPACE },
];

// 计算岗位细分的值
const computeJobSubdivide = (props) => {
	const { needJobSubdivide } = props;
	// 设置了jobSubdivide
	if (needJobSubdivide?.jobSubdivide) {
		return needJobSubdivide.jobSubdivide;
	}
	return JobSubdivideEnum.POSITION;
};
class SelectPosition extends Component {
	static contextType = SelectContext;
	constructor(props) {
		super(props);
		const jobSubdivide = computeJobSubdivide(props);
		this.state = {
			loading: true,
			disabledObj: this.getDisabledObj(props.disabledSelects),
			searchList: [],
			selectedKeys: [],
			expandedKeys: [],
			organizations: {},
			scrollViewHeight: 0,
			jobSubdivide,
		};
		this.treeBox = createRef();
		this.searchBox = createRef();
	}

	componentDidMount() {
		this.initList(this.props);
		const { needJobSubdivide } = this.props;
		let scrollViewHeight = 0;
		if (this.treeBox.current && this.searchBox.current) {
			const searchBox = window.getComputedStyle(this.searchBox.current);
			const JobSubdivideContainer = needJobSubdivide ? 48 : 0;
			scrollViewHeight =
				this.treeBox.current.parentElement.clientHeight -
				parseInt(searchBox.height) -
				parseInt(searchBox.marginTop) -
				parseInt(searchBox.marginBottom) -
				JobSubdivideContainer;
		}
		this.setState({
			selectedKeys: this.props.selects
				.filter((val) => val.flowUserSelectionType === 'position')
				.map((val) => `${val.sourceIdB}-${val.sourceIdA}`),
			scrollViewHeight,
		});
	}

	componentWillReceiveProps(nextProps) {
		const { organizations } = this.props;
		const { selects } = nextProps;
		if (organizations !== nextProps.organizations && nextProps.organizations) {
			this.initList(nextProps);
		}
		if (!isEqual(this.props.selects, selects)) {
			this.setState({
				selectedKeys: selects
					.filter((val) => val.flowUserSelectionType === 'position')
					.map((val) => `${val.sourceIdB}-${val.sourceIdA}`),
			});
		}
		// console.log(this.state.jobSubdivide,'this.state.jobSubdivide')
		// console.log(this.props.needJobSubdivide?.jobSubdivide,'this.props.needJobSubdivide?.jobSubdivide')
		// if (this.state.jobSubdivide !== this.props.needJobSubdivide?.jobSubdivide) {
		// 	this.setState({
		// 		jobSubdivide: computeJobSubdivide(nextProps)
		// 	});
		// }
	}

	//封装已选择列表
	getSelectObj = (selects = []) => {
		const obj = {};
		selects
			.filter((val) => val.flowUserSelectionType === 'position' && val.sourceTypeB !== 'source_business_department')
			.forEach((val) => {
				obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
			});
		return obj;
	};

	//封装不可选择列表
	getDisabledObj = (disabledList = []) => {
		const obj = {};
		disabledList
			.filter((val) => val.flowUserSelectionType === 'position' && val.sourceTypeB !== 'source_business_department')
			.forEach((val) => {
				obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
			});
		return obj;
	};

	/**
	 * 获取岗位
	 */
	initList = (props) => {
		this.setState({
			loading: true,
		});
		const { organizations, hiddenFilterFlag = 0, isLazyLoadData } = props;
		const { manageSceneFlag } = this.context;
		let api = '';
		if (isLazyLoadData) {
			api = '/org_v6/listOrganizationsByComponentV1';
		} else {
			api = '/org_v6/listOrganizationsByComponent';
		}
		const data = {
			organizationId: organizations.id,
			componentType: componentType.STATION,
			appId: window.$$context.appId,
			hiddenFilterFlag,
			manageSceneFlag,
		};
		callApi({
			api,
			data,
			success: ({ organizationTree = {} }) => {
				const { jobSubdivide } = this.state;
				const { jobPositionDTOS } = organizationTree;
				if (jobPositionDTOS?.length > 0) {
					const jobPositionDTOSWithjobSubdivide = setNodeJobSubdivide(jobPositionDTOS, jobSubdivide);
					organizations.jobPositionDTOS = jobPositionDTOSWithjobSubdivide;
				}
				this.setState({
					organizations: organizationTree,
					loading: false,
					...this.getData(organizationTree),
				});
			},
			error: () => {
				this.setState({ loading: false });
			},
		});
	};

	lazyLoadOrganization = ({ allData, children }) => {
		if (children) {
			return Promise.resolve();
		}
		const { id: organizationId } = allData;
		if (!organizationId) {
			return Promise.reject();
		}
		const { hiddenFilterFlag = 0 } = this.props;
		const { manageSceneFlag } = this.context;
		const { jobSubdivide } = this.state;
		const data = {
			organizationId,
			componentType: componentType.STATION,
			appId: window.$$context.appId,
			hiddenFilterFlag,
			manageSceneFlag,
		};
		return callApi({
			api: '/org_v6/listOrganizationsByComponentV1',
			data,
			success: (res) => {
				const organizations = res.organizationTree;
				const { jobPositionDTOS } = organizations;
				if (jobPositionDTOS?.length > 0) {
					const jobPositionDTOSWithjobSubdivide = setNodeJobSubdivide(jobPositionDTOS, jobSubdivide);
					organizations.jobPositionDTOS = jobPositionDTOSWithjobSubdivide;
				}
				Object.assign(allData, organizations);
				this.setState(({ organizations }) => ({
					organizations: {
						...organizations,
					},
				}));
			},
		});
	};

	getData = (organizations) => {
		let expandedKeys = [];
		if (organizations) {
			const id = 'dep' + String(organizations.id);
			expandedKeys = [id];
		}
		return { expandedKeys };
	};

	// 改变某个组的全选
	changeGroupSelectAll = (currentNode, selectedAll, info) => {
		const { selects, addItems, removeItems } = this.props;
		const { disabledObj } = this.state;
		// 展开该节点下属的岗位
		const flatGroup = (nodeList = [], curGroup = []) => {
			let newGroup = curGroup.concat([]);
			for (const nodeItem of nodeList) {
				const { id, selectedFlag, jobPositionDTOS = [], children = [] } = nodeItem;
				const nodeDisabled = disabledObj[id] || selectedFlag === 0;
				if (nodeDisabled) continue;
				const purePositionList = jobPositionDTOS.filter((infoItem) => infoItem.departmentId);
				newGroup = newGroup.concat(purePositionList);
				if (children.length > 0) {
					newGroup = [].concat(flatGroup(children, newGroup));
				}
			}
			return newGroup;
		};
		const groupList = flatGroup([currentNode]);
		if (selectedAll) {
			// 找出已选中的，并删除
			const removeList = groupList.filter((item) => {
				return selects.some((node) => node.sourceIdA === item.id && node.sourceIdB === item.departmentId);
			});
			removeItems(this.transToSource(removeList));
		} else {
			// 找出还未选中的，并添加
			const addList = groupList.filter((item) => {
				return !selects.some((node) => node.sourceIdA === item.targetId && node.sourceIdB === item.departmentId);
			});
			addItems(this.transToSource(addList));
		}
	};

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = (list) => {
		const { selects, isLazyLoadData } = this.props;
		const { disabledObj = {} } = this.state;
		// 整个组是否全选
		const validateSelectedAll = (curNodeList = []) => {
			const validateResult = curNodeList.every((curNode) => {
				const { jobPositionDTOS = [], children = [] } = curNode;
				const purePositionList = jobPositionDTOS.filter(
					(positionItem) =>
						positionItem.departmentId && !disabledObj[positionItem.id] && positionItem.selectedFlag !== 0,
				);
				const currentSetsFlag = purePositionList.every((purePositionItem) =>
					selects.some(
						(selectNode) =>
							selectNode.sourceIdA === purePositionItem.id && selectNode.sourceIdB === purePositionItem.departmentId,
					),
				);
				if (currentSetsFlag) {
					if (children.length > 0) {
						return validateSelectedAll(children);
					}
					return true;
				}
				return false;
			});
			return validateResult;
		};
		const genFunc = (list) => {
			const { disabledObj = {}, jobSubdivide } = this.state;
			return list.map((node) => {
				let { children = [], name, id, jobPositionDTOS = [], selectedFlag, departmentId, isLeaf, isPosition } = node;
				const selectedAll = validateSelectedAll([node]);
				if (jobPositionDTOS.length > 0) {
					jobPositionDTOS.forEach((val) => {
						val.isPosition = true;
					});
					children = children.concat(jobPositionDTOS);
				}
				/**
				 * 结果中是否有该岗位,不限制岗位的选中状态
				 * @type {boolean}
				 *
				 */
				const nodeWithoutJobSubdivide = selects.find((item) => {
					return item.sourceIdA === id && item.sourceIdB === departmentId;
				});
				/**
				 * 结果中是否有该岗位, 区分岗位细分
				 * @type {boolean}
				 */
				const nodeInResult =
					nodeWithoutJobSubdivide && nodeWithoutJobSubdivide?.sourceDataA?.jobSubdivide === jobSubdivide;
				/**
				 * id相同但是岗位细分不同
				 */
				const diffJobSubdivide = nodeWithoutJobSubdivide && !nodeInResult;
				const nodeDisabled = disabledObj[id] || selectedFlag === 0 || diffJobSubdivide;
				if (!isPosition) {
					return (
						<TreeNode
							key={`dep${id}`}
							disabled={nodeDisabled}
							selectable={false}
							allData={node}
							isLeaf={isLazyLoadData && !!isLeaf}
							title={
								<div title={null} className={`${prefixClx}-node`}>
									<Popover content={name} mouseEnterDelay={0.5} placement="topLeft">
										<span className={`${prefixClx}-node-name`}>
											<FolderOpenOutlined className="type-icon" />
											{name}
										</span>
									</Popover>
									{isLazyLoadData || nodeDisabled ? null : (
										<span
											className={`${prefixClx}-node-handle select-all`}
											onClick={(e) => this.changeGroupSelectAll(node, selectedAll, e)}
										>
											{selectedAll ? '取消全选' : '全选'}
										</span>
									)}
								</div>
							}
						>
							{genFunc(children)}
						</TreeNode>
					);
				}
				const selected = (() => {
					if (!departmentId) {
						return false;
					}
					return nodeInResult;
				})();
				return (
					<TreeNode
						key={isPosition ? `${departmentId}-${id}` : `dep${id}`}
						disabled={nodeDisabled}
						allData={node}
						selectable={!!isPosition}
						isLeaf={true}
						title={
							<div title={null} className={`${prefixClx}-node`}>
								<Popover content={name} mouseEnterDelay={0.5} placement="topLeft">
									<span className={`${prefixClx}-node-name`}>
										{(() => {
											/**
											 * 获取图标
											 */
											if (isPosition) {
												if (node.jobSubdivide === JobSubdivideEnum.SPACE) {
													return <SkinFilled className="type-icon" />;
												}
												return <SkinOutlined className="type-icon" />;
											}
											return <FolderOpenOutlined className="type-icon" />;
										})()}
										{name}
									</span>
								</Popover>
								<span className={`${prefixClx}-node-handle`}>
									<Checkbox disabled={!isPosition || nodeDisabled} checked={selected} />
								</span>
							</div>
						}
					/>
				);
			});
		};
		// 递归生成 react node
		const nodes = genFunc(list);
		return nodes;
	};

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({
			expandedKeys: keys,
		});
	};

	/**
	 * 数据整合成统一格式
	 */
	transToSource = (sNode) => {
		const { needAllData, needJobSubdivide } = this.props;
		// const needAllData = true;
		// console.log(this.props);
		const temp = sNode.map((position) => ({
			selectionName: `${position.departmentName}/${position.name}`,
			flowUserSelectionType: 'position',
			sourceIdA: position.id,
			sourceTypeA: 'source_position',
			// sourceDataA: position.allData,
			sourceDataA: (() => {
				if (needAllData) {
					return position;
				}
				if (needJobSubdivide) {
					return {
						jobSubdivide: position.jobSubdivide,
					};
				}
				// needAllData ? position : undefined
			})(),
			sourceIdB: position.departmentId,
			sourceTypeB: 'source_department',
		}));
		return temp;
	};

	/**
	 * 选中某项
	 * @param {string[]} selectedKeys
	 */
	onSelect = (selectedKeys, info) => {
		const { addItems, removeItems } = this.props;
		const sNode = info.node;
		const param = {
			selectedKeys,
		};
		if (sNode) {
			const newSelect = this.transToSource([sNode.allData]);
			// console.log(newSelect, 'newSelect')
			if (info.selected) {
				addItems(newSelect);
			} else if (!info.selected) {
				removeItems(newSelect);
			}
		}
		this.setState(param);
	};

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = (list) => {
		const { disabledObj } = this.state;
		const { selects } = this.props;
		return list.map((node) => {
			const { name, id, selectedFlag, departmentId, departmentName } = node;
			const selected = (() => {
				if (!departmentId) {
					return false;
				}
				return selects.some((selectNode) => selectNode.sourceIdA === id && selectNode.sourceIdB === departmentId);
			})();
			return (
				<TreeNode
					disabled={disabledObj[id] || selectedFlag === 0}
					allData={node}
					key={`${departmentId}-${id}`}
					title={
						<div className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>
								{(() => {
									if (node.jobSubdivide === JobSubdivideEnum.SPACE) {
										return <SkinFilled className="type-icon" />;
									}
									return <SkinOutlined className="type-icon" />;
								})()}
								{`${departmentName}/${name}`}
							</span>
							<span className={`${prefixClx}-node-handle`}>
								<Checkbox disabled={!departmentId} checked={selected} />
							</span>
						</div>
					}
				/>
			);
		});
	};

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		const { privilegeFilterFlag = 0, hiddenFilterFlag = 0 } = this.props;
		const { manageSceneFlag } = this.context;
		keywords = keywords.trim();
		const { organizations } = this.state;
		if (!keywords) {
			return this.setState({
				searchText: '',
			});
		}
		this.setState({ loading: true, searchText: keywords });
		callApi({
			api: '/org_v6/searchJobPositions',
			data: {
				organizationId: organizations.id,
				keywords,
				privilegeFilterFlag,
				appId: window.$$context.appId,
				hiddenFilterFlag,
				manageSceneFlag,
			},
			success: (positions = []) => {
				const jobPositionDTOSWithjobSubdivide = setNodeJobSubdivide(positions, this.state.jobSubdivide);

				this.setState({
					searchList: jobPositionDTOSWithjobSubdivide,
					loading: false,
				});
			},
		});
	};

	// 防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	changeJobSubdivide = (jobSubdivide) => {
		this.setState({
			jobSubdivide,
		});
		const { organizations, searchList } = this.state;
		const loop = (list) => {
			list.forEach((item) => {
				// item.jobPositionDTOS &&
				const jobPositionDTOS = item.jobPositionDTOS?.map((position) => {
					// position.jobSubdivide = jobSubdivide;
					return {
						...position,
						jobSubdivide,
					};
				});

				item.jobPositionDTOS = jobPositionDTOS;
				if (item.children) {
					loop(item.children);
				}
			});
		};
		//添加切换逻辑
		loop([organizations]);
		searchList.forEach((item) => {
			item.jobSubdivide = jobSubdivide;
		});
		this.setState({
			organizations: { ...organizations },
			searchList: [...searchList],
		});
	};

	render() {
		const {
			loading,
			searchText,
			searchList,
			selectedKeys,
			expandedKeys,
			organizations,
			scrollViewHeight,
			jobSubdivide,
		} = this.state;
		const { isLazyLoadData, needJobSubdivide } = this.props;
		return (
			<Col className="tree-box" ref={this.treeBox}>
				{needJobSubdivide && (
					<div className="job_subdivide">
						<Radio.Group
							optionType="button"
							options={JobSubdivideOptions}
							value={jobSubdivide}
							onChange={(e) => {
								const jobSubdivide = e.target.value;
								this.changeJobSubdivide(jobSubdivide);
							}}
						/>
					</div>
				)}
				<div className="select-box-search" ref={this.searchBox}>
					<Input
						placeholder="请输入岗位"
						onChange={(e) => this.searchByKeywordsDebounced(e.target.value)}
						prefix={<SearchOutlined />}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{searchText ? (
						loading ? (
							<Spin className="tree-box-center" />
						) : searchList.length < 1 ? (
							<div className="tree-box-center">未找到相关结果</div>
						) : (
							<Tree
								multiple
								height={scrollViewHeight}
								selectedKeys={cloneDeep(selectedKeys)}
								onSelect={this.onSelect}
								selectable
							>
								{this.generateList(searchList)}
							</Tree>
						)
					) : loading ? (
						<Spin className="tree-box-center" />
					) : (
						<Tree
							multiple
							height={scrollViewHeight}
							expandedKeys={cloneDeep(expandedKeys)}
							selectedKeys={cloneDeep(selectedKeys)}
							onExpand={this.onExpand}
							onSelect={this.onSelect}
							selectable
							loadData={isLazyLoadData ? this.lazyLoadOrganization : undefined}
						>
							{this.generateNodes([organizations])}
						</Tree>
					)}
				</div>
			</Col>
		);
	}
}

SelectPosition.propTypes = {
	// 组织架构数据
	organizations: PropTypes.object.isRequired,
	hiddenFilterFlag: PropTypes.number,
	organizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

	/* 以下是configs额外传进来的参数 */
	// 扩展的树节点，格式为 [{id: -1, name: '不限部门', type: 'source_unlimited_department', childrens: [...]}]
	extendTree: PropTypes.array,
	disabledSelects: PropTypes.array,
	selects: PropTypes.array,
	addItems: PropTypes.func.isRequired,
	removeItems: PropTypes.func.isRequired,
	needAllData: PropTypes.bool,
	isLazyLoadData: PropTypes.bool, // 是否使用对数据进行懒加载的功能
	lazyLoadOrganization: PropTypes.func, // 使用懒加载数据的时候，需要在获取子部门时调用的方法
};

export default SelectPosition;
export { JobSubdivideEnum };
